<script setup>
import { inject, ref } from 'vue';
import PolylineMeasureLayerManager from './PolylineMeasureLayerManager';

defineProps({
  options: {
    type: Object,
    default: () => {
      return {}
    }
  }
});

const isActive = ref(false);
const polylineMeasureLayer = ref(null);

const emit = defineEmits(['isActive']);

const $map = inject('$map');

const toggleMeasure = () => {
  if (isActive.value) {
    polylineMeasureLayer.value.clear();
    $map.removeLayer(polylineMeasureLayer.value);
    polylineMeasureLayer.value = null;
    isActive.value = false;
    emit('isActive', false);
  } else {
    polylineMeasureLayer.value = new PolylineMeasureLayerManager($map);
    polylineMeasureLayer.value.setMode('Line');
    $map.addLayer(polylineMeasureLayer.value);
    isActive.value = true;
    emit('isActive', true);
  }
}

defineExpose({
  toggleMeasure
})
</script>

<template>
  <button :class="{ active: isActive }" @click="toggleMeasure">
    <i :class="options.icon" />
  </button>
</template>